<template>
  <micro-schema :ld-json-data="jsonData" />
</template>
<script lang="ts" setup>
import { isEmpty } from "lodash-es";
import { type MicroSchemaBreadcrumbList as MicroSchemaBreadcrumbListType } from "../interfaces";
import { SCHEMA_CONTEXT_LINK } from "../variables";
import { type ProductBreadcrumb } from "~/modules/catalog/types";
import { type Breadcrumb } from "~/types/breadcrumbs";
import { MicroSchema } from "~/modules/micro-schema/components/MicroSchema";

const props = defineProps<{
  breadcrumbs: (Breadcrumb | ProductBreadcrumb)[];
}>();

const { store } = useI18nExtend();

const jsonData = computed<MicroSchemaBreadcrumbListType | undefined>(() => {
  if (isEmpty(props.breadcrumbs)) {
    return undefined;
  }

  return {
    "@context": SCHEMA_CONTEXT_LINK,
    "@type": "BreadcrumbList",
    itemListElement: props.breadcrumbs.map((i, idx) => ({
      "@type": "ListItem",
      position: idx + 1,
      name: i.label,
      item: `${store.value.domain}${i.link.slice(1)}`,
    })),
  };
});
</script>
